import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketTabCss = ":host{position:relative;color:var(--core-text-20-color);cursor:pointer}:host([aria-selected='true']){color:var(--core-text-10-color)}:host([aria-selected='true'])::after{content:'';position:absolute;bottom:0;left:0;width:100%;height:2px;border-radius:2px 2px 0 0;background:var(--core-text-10-color)}:host(:first-child){margin-left:0}:host(:last-child){margin-right:0}";

const MarketTab = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketTabSelected = createEvent(this, "marketTabSelected", 7);
  }
  /**
   * If this tab is not currently selected, emits a `marketTabSelected` event
   */
  select() {
    if (this.el.getAttribute('aria-selected') === 'true') {
      return Promise.resolve();
    }
    this.marketTabSelected.emit();
    return Promise.resolve();
  }
  /**
   * Gets the `market-tab-panel` with an `id` matching the `aria-controls` value of this tab
   */
  getAssociatedPanel() {
    const controls = this.el.getAttribute('aria-controls');
    const panelEl = document.querySelector(`${getNamespacedTagFor('market-tab-panel')}#${controls}`) || undefined;
    return Promise.resolve(panelEl);
  }
  handleKeyUp(e) {
    const siblings = [...this.el.parentElement.children];
    const currentIndex = siblings.indexOf(this.el);
    if (e.key === 'ArrowRight') {
      siblings[(currentIndex + 1) % siblings.length].focus();
    }
    if (e.key === 'ArrowLeft') {
      siblings[(currentIndex - 1 + siblings.length) % siblings.length].focus();
    }
    if (e.key === 'Enter' || e.key === ' ') {
      this.select();
    }
  }
  handleKeyDown(e) {
    if (e.key === ' ') {
      e.preventDefault();
    }
  }
  render() {
    return (h(Host, { class: "market-tab", onClick: () => this.select(), onKeyDown: (e) => this.handleKeyDown(e), onKeyUp: (e) => this.handleKeyUp(e), "aria-selected": "false", tabindex: "-1", role: "tab" }, h("slot", null)));
  }
  get el() { return getElement(this); }
};
MarketTab.style = marketTabCss;

export { MarketTab as market_tab };
